import _ from 'underscore';

app.EnterpriseTagDetailsView = app.BaseDetailsView.extend({
  initialize() {
    app.BaseDetailsView.prototype.initialize.apply(this, arguments);

    this.listenTo(app.orgList, 'reset', this.render);
    this.listenTo(app.orgList, 'add', this.render);
    this.listenTo(app.orgList, 'remove', this.render);
    this.listenTo(app.orgList, 'change:enterpriseTagId', this.render);
  },

  viewWasAddedToDom() {
    app.BaseDetailsView.prototype.viewWasAddedToDom.apply(this, arguments);

    if (!app.orgList.hasBeenFetched()) {
      app.orgList.fetch({ reset: true });
    }
  },

  render() {
    app.BaseDetailsView.prototype.render.apply(this);

    if (this.model.isNew()) {
      return this;
    }

    const orgsWithTag = app.orgList.models.filter((org) => {
      return org.get('enterpriseTagId') === this.model.id;
    });
    const linksHtml = orgsWithTag
      .sort((a, b) => {
        return a.displayName().localeCompare(b.displayName());
      })
      .map((org) => {
        return `<div><a href="${org.bureauUrl()}">${_.escape(org.displayName())}</a></div>`;
      })
      .join('');

    const afterFieldView = this.fieldGroupView.fieldViewsByField.magicCopyPermission;
    $(
      this.valueDisplayTemplate({
        label: 'Orgs with this tag:',
        value: linksHtml.length ? linksHtml : 'No orgs tagged yet',
      }),
    ).insertAfter(afterFieldView.$el);

    return this;
  },
});
